import { Construction } from '@mui/icons-material'
import { StyledContainerCentered } from '../../styles/ContainerStyles'

type DefaultTechnologyImageProps = {
  size: number
}

const DefaultTechnologyLogo = ({ size }: DefaultTechnologyImageProps) => {
  return (
    <StyledContainerCentered
      sx={{ width: size, height: size, borderRadius: size, bgcolor: 'background.lighter', color: 'text.main' }}
    >
      <Construction sx={{ width: size / 1.75 }} />
    </StyledContainerCentered>
  )
}

export default DefaultTechnologyLogo
